// extracted by mini-css-extract-plugin
export default {"span":"NavLink_span__AKzGl","active":"NavLink_active__iqla8"};